<div class="container">
  <div class="row mt-5">
    <div class="col-md-12">
      <div class="text-center" style="font-weight:bold; font-size: 1.4em; text-decoration:underline">Registration</div><br />
      Complete the form below to receive settlement-related updates. Then, if the Court decides to give the proposed Settlement
      final approval, you will be notified by email or mail when a claim form becomes available.<br /><br />
    </div>
  </div>
  <div>
    <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()" autocomplete="off" novalidate #formRef="ngForm">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="claimantType">Filer Type: Third-party Payor (consumption by their members, employees, insureds, participants, or beneficiaries)</label>
            <input type="text" class="form-control" id="claimantType" formControlName="claimantType" placeholder="Third-party Payor"
                   autocomplete="off" trim="blur" readonly />
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="name1">Company or Health Plan Name:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="name1" formControlName="name1" placeholder="" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name1.errors }" />
            <div *ngIf="submitted && f.name1.errors" class="invalid-feedback">
              <div *ngIf="f.name1.errors.required">This field is required</div>
              <div *ngIf="f.name1.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.name1.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens,
                brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="name2">Contact Name:</label>
            <input type="text" class="form-control" id="name2" formControlName="name2" placeholder="" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name2.errors }" />
            <div *ngIf="submitted && f.name2.errors" class="invalid-feedback">
              <div *ngIf="f.name2.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.name2.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.name2.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens,
                brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="street1">Mailing Address 1: <span style="color:red" class="required"> *</span> </label>
            <input type="text" class="form-control" id="street1" formControlName="street1" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
            <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
              <div *ngIf="f.street1.errors.required">This field is required</div>
              <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.street1.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="street2">Mailing Address 2: </label>
            <input type="text" class="form-control" id="street2" formControlName="street2" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
            <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
              <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.street2.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.street2.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="city">City: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="city" formControlName="city" placeholder="" autocomplete="off"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
            <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
              <div *ngIf="f.city.errors.required">This field is required</div>
              <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
              <div *ngIf="f.city.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens,
                brackets,
                ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label class="titleBold" for="state">State:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
            <option value="">Please select a State</option>
            <option *ngFor="let allstate of allStates">
              {{allstate.Name}}
            </option>
          </select>
          <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
            <div *ngIf="f.state.errors.required">This field is required</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="zip">Zip Code: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="zip" formControlName="zip"
                   placeholder="Zip Code: (XXXXX or XXXXX-XXXX)" autocomplete="off" trim="blur"
                   [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
            <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
              <div *ngIf="f.zip.errors.required">This field is required</div>
              <div *ngIf="f.zip.errors.pattern">
                US zip Code with format 99999 or 99999-9999 alone are
                accepted
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="email">Email Address: </label>
            <input type="text" class="form-control" id="email" formControlName="email" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.maxlength">This field must not be at greater 255 characters</div>
              <div *ngIf="f.email.errors.pattern">This is not a valid email address</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="phone1">Telephone Number: </label>
            <input type="text" mask="000 000-0000" class="form-control" id="phone1" formControlName="phone1" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.phone1.errors }" />
            <div *ngIf="submitted && f.phone1.errors" class="invalid-feedback">
              <div *ngIf="f.phone1.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.phone1.errors.maxlength">This field must not be at greater 10 digits</div>
              <div *ngIf="f.phone1.errors.pattern">Only use numbers</div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
            <div *ngIf="submitted && f.googleRecaptchaToken.errors">
              <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:#dc3545; font-size:80%">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
        <div class="col-md-12 text-center" style="font-weight:bold">
          Submission Failed, you will need to send your registration information to the following <a href="mailto:info@GenericDrugsEndPayerSettlement.com">email address</a>.<br />
          Thank You.
        </div>
      </div>-->
      <br />
      <!--<br />
      <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
        <div class="col-md-12 text-center" style="font-weight:bold">
          Submission Failed, click <a href="./assets/Docs/.pdf" target="_blank">here </a>
          to download a copy of the form and send it via <a href="mailto:info@GenericDrugsEndPayerSettlement.com">email</a>.<br />
          Thank You.
        </div>
      </div>
      <br />-->
      <ul class="list-inline text-center">
        <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
      </ul>
    </form>
  </div>
</div>


